import type { RoomConfig } from '@tctp/protocol';

async function errorMessage(res: Response, fallback: string): Promise<string> {
  try {
    const body = (await res.json()) as { message?: string; error?: string };
    return body.message ?? body.error ?? fallback;
  } catch {
    return fallback;
  }
}

export async function createRoom(hostToken: string, config: Partial<RoomConfig>): Promise<string> {
  const res = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ hostToken, config }),
  });
  if (res.status !== 201) throw new Error(await errorMessage(res, `could not create the game (${res.status})`));
  return ((await res.json()) as { roomId: string }).roomId;
}

export async function roomInfo(roomId: string): Promise<{ exists: boolean; ended: boolean }> {
  const res = await fetch(`/api/rooms/${encodeURIComponent(roomId)}`);
  if (!res.ok) throw new Error(`room lookup failed (${res.status})`);
  return (await res.json()) as { exists: boolean; ended: boolean };
}
